import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { IJsonDate } from '../../System/IJsonDate';
import { FrequencyType } from '../../Constants/Enums/Domain/FrequencyType';

declare var IS_RUNNING_IN_APP_POOL;

export class NextPaymentDateClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(asAt: IJsonDate, frequency: FrequencyType): Promise<IJsonDate, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Payments/NextPaymentDate/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { asAt: asAt, frequency: frequency }

    return AjaxWrapper.get<IJsonDate, any>(url, data);
  }
}

